import { CssBaseline } from '@mui/material';
import { Login } from 'login/login';
import { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { BrandsResolver, NewQuoteResolver, QuoteDetailResolver, QuotesResolver } from 'routing';
import { PrivateRoute } from 'routing/auth-guard';
import { ROUTES } from 'routing/routes';
import { AuthLayout, PublicLayout } from 'shared/layouts';
import { useService } from 'shared/providers';
import { RegisterAppUpdate } from 'startup/register-app-update';
import { gtag } from 'startup/register-google-analytics';

const pages = [
  {
    exact: true,
    route: Route,
    path: ROUTES.login,
    component: Login,
    layout: PublicLayout,
  },
  {
    exact: true,
    route: PrivateRoute,
    path: ROUTES.brands,
    component: BrandsResolver,
    layout: AuthLayout,
  },
  {
    exact: true,
    route: PrivateRoute,
    path: ROUTES.quotes,
    component: QuotesResolver,
    layout: AuthLayout,
  },
  {
    exact: true,
    route: PrivateRoute,
    path: ROUTES.newQuote,
    component: NewQuoteResolver,
    layout: AuthLayout,
  },
  {
    exact: true,
    route: PrivateRoute,
    path: ROUTES.quoteDetail,
    component: QuoteDetailResolver,
    layout: AuthLayout,
  },
];

export default function App() {
  const { pathname, search } = useLocation();
  const {
    appConfig: { googleTagId, enableGoogleAnalytics },
  } = useService();

  useEffect(() => {
    if (enableGoogleAnalytics) {
      gtag('config', googleTagId, {
        page_path: pathname + search,
      });
    }
  }, [pathname, search, enableGoogleAnalytics, googleTagId]);

  return (
    <>
      <CssBaseline />
      <RegisterAppUpdate />
      <Switch>
        {pages.map(({ path, exact, component: Component, layout: Layout, route: Route }, i) => (
          <Route key={i} exact={exact} path={path}>
            <Layout>
              <Component />
            </Layout>
          </Route>
        ))}
        <Redirect to={ROUTES.login} />
      </Switch>
    </>
  );
}
